module.exports = __webpack_public_path__ + "static/schema-theory-ex-f9cdb59a00187736319662869b1a2941.png";